import React from 'react'
import { Row } from '@softura/fluentuipackage'

interface IProps {
  className?: string,
  children?: any,
  'data-attribute'?: any,
}
const RowContainer = ({ className = '', children, 'data-attribute': dataAttribute }:IProps) => {
  return <Row className={className} data-attribute={dataAttribute}>{children}</Row>
}

export default RowContainer
